import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import authService from '../services/authService';
import { isSuper, logout } from '../slices/authSlice';
import { products, setRole } from '../slices/productSlice';

export const useAuth = () => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const [auth, setAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [role, setRoles] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const authUser = async () => {
      if (user) {
        try {
          const resPermission = await authService.permission();
          setRoles(resPermission.permission);
          if (isAuthenticated) {
            dispatch(products());
            dispatch(setRole(resPermission.permission));
            dispatch(isSuper(resPermission.is_superuser));
          }
        } catch (error) {
          dispatch(logout());
        }
      } else {
        setAuth(false);
      }
      setLoading(false);
    };
    authUser();
    setAuth(isAuthenticated);
  }, [user, isAuthenticated]);

  return { auth, loading, role };
};
